<div class="main-content">
  <div class="flex flex-col gap-5">
    <p-card>
      <ng-template #header>
        <h1 class="contentHeader">
          Logowanie przez kwalifikowany podpis elektroniczny
        </h1>
      </ng-template>
      <ng-template #title>Podpisywanie oświadczenia</ng-template>
      <div class="flex flex-col gap-5">
        <app-info-message
          [label]="
            'Kwalifikowany podpis elektroniczny ma skutek prawny równoważny podpisowi własnoręcznemu zgodnie z art. 25 ust. 2 Rozporządzenia Parlamentu Europejskiego i Rady (UE) nr 910/2014 z dnia 23 lipca 2014 r. w sprawie identyfikacji elektronicznej i usług zaufania w odniesieniu do transakcji elektronicznych na rynku wewnętrznym oraz uchylającego dyrektywę 1999/93/WE.'
          "
        ></app-info-message>
        <ol class="list-decimal pl-5">
          <li>
            Umieść kartę z certyfikatem kwalifikowanym w czytniku albo podłącz
            token (pendrive), który zawiera kartę z certyfikatem kwalifikowanym.
          </li>
          <li>
            Zapoznaj się z oświadczeniem i jeśli się z nim zgadzasz, wybierz
            „Podpisz oświadczenie”.
          </li>
        </ol>
        <div id="statement">
          <span class="font-bold">Oświadczenie:</span>
          <br />
          <p>
            Proszę o przydzielenie dostępu lub rejestrację w portalu przy użyciu
            kwalifikowanego podpisu.
          </p>
        </div>
        <div class="flex justify-between">
          <p-button
            styleClass="customInfoButton outlined"
            size="small"
            [label]="'Anuluj'"
            (click)="navigateToLoginMethod()"
          />
          <p-button
            styleClass="customInfoButton"
            size="small"
            [label]="'Podpisz oświadczenie'"
            (click)="sign()"
          />
        </div>
      </div>
    </p-card>
  </div>
</div>
